export const NAVIGATION = {
  WORKOUT_TRACKER: 'WORKOUT_TRACKER',
  HUB: 'HUB',
  DASHBOARD: 'DASHBOARD',
  SETTING: 'SETTING',
  CHALLENGE: 'CHALLENGE',
  MEAL_TRACKER: 'MEAL_TRACKER',
};

export const EXERCISE_STATUS = {
  COMPLETE: 'COMPLETE',
  INCOMPLETE: 'INCOMPLETE',
};

export const DASHBOARD = {
  HOME: 'HOME',
  HABIT: 'HABIT',
  WEIGHT_PROGRESS: 'WEIGHT_PROGRESS',
  BODY_PROGRESS: 'BODY_PROGRESS',
  MEASUREMENT_PROGRESS: 'MEASUREMENT_PROGRESS',
  PERSONAL_INFO: 'PERSONAL_INFO',
  PROGRAM: 'PROGRAM',
  GOAL: 'GOAL',
  CHALLENGE: 'CHALLENGE',
};

export const SCANNING_STATUS = {
  READY: 'READY',
  ANALYZING: 'ANALYZING',
  DONE: 'DONE',
  STOP: 'STOP',
};

export const SIGNUP_STEPS = {
  NAME: 'NAME',
  NICKNAME: 'NICKNAME',
  GENDER_AGE: 'GENDER_AGE',
  HEIGHT_WEIGHT: 'HEIGHT_WEIGHT',
  NATIONALITY: 'NATIONALITY',
  EMAIL: 'EMAIL',
  PASSWORD: 'PASSWORD',
  GOAL: 'GOAL',
};

export const GOAL_STEPS = {
  END_GOAL: 'END_GOAL',
  DAILY_WORKOUT: 'DAILY_WORKOUT',
  DAILY_CALORIE: 'DAILY_CALORIE',
  DAILY_PCF: 'DAILY_PCF',
  SUMMARY: 'SUMMARY',
  DONE: 'DONE',
};

export const GENDER = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
};

export const TIMER_STATUS = {
  READY: 'READY',
  PREP: 'PREP',
  EXERCISE: 'EXERCISE',
  REST: 'REST',
  SET_REST: 'SET_REST',
  CYCLE_REST: 'CYCLE_REST',
  DONE: 'DONE',
  PAUSE: 'PAUSE',
};

export const EXERCISE_MODE = {
  TIME: 'TIME',
  REPS: 'REPS',
};

export const WEIGHT_UNIT = {
  KG: 'KG',
  LB: 'LB',
};
